import { useRegisterSW } from "virtual:pwa-register/react";

const useAppUpdate = () => {
    const {
        needRefresh: [needRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(_r) {
            console.warn("SW Registered: " + JSON.stringify(_r));
        },
        onRegisterError(error) {
            console.error("SW registration error", error);
        },
    });

    return { needRefresh, updateServiceWorker }; // The modal content is shown in the toast, so return null here
};

export default useAppUpdate;
